// src/modules/retail-product-finder/components/constants.js
//
// Shared enums / formatters for the Retail Product Finder module.

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA",
  "KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT",
  "VA","WA","WV","WI","WY","DC",
];

export const EMPTY_LOCATION = {
  name: "",
  chain: "",
  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  postal_code: "",
  country: "USA",
  latitude: "",
  longitude: "",
  products: [],
  notes: "",
  is_active: true,
};

/** "123 Main St, Austin, TX 78701" — skips blanks cleanly. */
export function formatAddress(loc) {
  const street = [loc?.address_line1, loc?.address_line2].filter(Boolean).join(" ");
  const cityState = [loc?.city, loc?.state].filter(Boolean).join(", ");
  return [street, cityState, loc?.postal_code].filter(Boolean).join(" · ");
}

export function fmtDate(iso) {
  if (!iso) return "—";
  // A bare `YYYY-MM-DD` (which is what `last_sold_on` is — a DATE, not a
  // timestamp) parses as UTC midnight, so west of Greenwich it renders as the
  // day before. Build those from their own parts and leave real timestamps alone.
  const ymd = typeof iso === "string" && /^\d{4}-\d{2}-\d{2}$/.test(iso);
  const d = ymd
    ? new Date(Number(iso.slice(0, 4)), Number(iso.slice(5, 7)) - 1, Number(iso.slice(8, 10)))
    : new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

// `parseProducts()` lived here and is GONE (backlog item 100). It split a
// comma-separated free-text box into whatever the typist wrote, which is one of
// the three writers that filled the public product filter with four spellings of
// the same wine. The editor now picks from the tenant's catalog through
// `utils/productCatalog.js`; canonicalisation belongs there, with the matcher.
